module.exports = __webpack_public_path__ + "static/media/Red-B.c09747dc.png";